"use client";

import { useEffect, useState } from "react";
import Image from "next/image";

import s from "./styles";

import FooterCopyrightComponent from "@app/FooterCopyright";

import logjs from "@metrojs/logjs";
const log = new logjs("login/page");

import { useLogin } from "./useLogin";
import { providers } from "@lib/client";
const { useWebAppContext } = providers;

/**
 * ログインページコンポーネント (Seller用)
 * htdocs_yz/app/controllers/wreckertop_controller.php::login を移植
 *
 * @param {Object} props - コンポーネントのプロパティ
 * @param {Object} props.params - 動的ルートパラメータ
 * @param {Object} props.searchParams - URLのクエリパラメータ
 * @returns {JSX.Element} ログインページのコンポーネント
 */
export default function Page() {
  // コンテキストの使用
  const webAppContext = useWebAppContext();
  const { state, actions, params, searchParams } = webAppContext || {};

  const { mode } = params;

  //log.debug(`mode: ${mode}`, { params, searchParams });

  const [isMounted, setIsMounted] = useState(false);
  const [formData, formProps] = useLogin(state, actions, params);
  const { form, error, isLoading } = formData;

  // ハイドレーションを無効にする
  useEffect(() => {
    setIsMounted(true);
  }, []);

  // Enterキーでログイン
  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      formProps.login(mode);
    }
  };

  if (!isMounted) {
    return null;
  }

  return (
    <>
      <s.BodyBackground>
        <s.LoginContainer style={{ backgroundColor: "transparent" }}>
          <s.Header style={{ backgroundColor: mode === "ichinen" ? "beige" : "transparent" }}>
            <s.Logo>
              <Image src="/images/do_logo_only.svg" alt="DirectOrder" width={150} height={40} style={{ maxHeight: "48px", width: "auto" }} />
            </s.Logo>

            <s.Container>
              <s.Main>
                <s.LoginBox>
                  <s.LoginForm>
                    {/* @@@ コメントアウト確認 */}
                    <s.LoginTitle>部品を売る → 会員様ログイン</s.LoginTitle>
                    {/* <s.LoginTitle>部品を売る/車輌を買う → 会員様ログイン</s.LoginTitle> */}
                    <s.LoginContent>
                      <s.LoginTable>
                        <tbody>
                          <tr>
                            <th>ID</th>
                            <td>
                              {formProps.input_login_id({
                                maxLength: 16,
                                onKeyPress: handleKeyPress,
                              })}
                            </td>
                          </tr>
                          <tr>
                            <th>パスワード</th>
                            <td>
                              {formProps.input_password({
                                maxLength: 100,
                                onKeyPress: handleKeyPress,
                              })}
                            </td>
                          </tr>
                        </tbody>
                      </s.LoginTable>

                      {error && <s.ErrorMessage>{error}</s.ErrorMessage>}

                      <s.LoginButton
                        onClick={async (e) => {
                          e.preventDefault();
                          log.debug(`e: ${e}`);
                          try {
                            formProps.login(mode);
                          } catch (error) {
                            log.error(`error: ${error}`);
                          }
                        }}
                        disabled={isLoading}
                      >
                        {isLoading ? "ログイン中..." : "ログイン"}
                      </s.LoginButton>
                    </s.LoginContent>
                  </s.LoginForm>
                </s.LoginBox>

                <s.MessageArea>
                  <s.MessageContent>
                    <h1>ダイレクトオーダー事務局</h1>
                    <p>
                      <strong>TEL:092-710-3912</strong>
                      <span>(平日 10:00～17:00)</span>
                      <br />
                      ・申込みに関するお問合せ
                      <br />
                      ・操作方法に関するお問合せ
                      <br />
                      ・ID、パスワードに関するお問合せ
                      <br />
                      ・その他の一般的なお問合せ
                      <span className="emergency">
                        ■サーバ障害　緊急連絡専用
                        <br />
                        <a href="mailto:support@direct-order-sys.jp">
                          {/* <Image src="/images/emergency.png" alt="緊急連絡" width={160} height={100} /> */}
                          support@direct-order-sys.jp
                        </a>
                        <br />
                        ・サーバ障害に関する緊急連絡専用となります。
                      </span>
                    </p>
                  </s.MessageContent>
                </s.MessageArea>
              </s.Main>
            </s.Container>
          </s.Header>
        </s.LoginContainer>

        <s.MainContent>
          <s.Footer>
            自動車の中古・リビルド・優良パーツ(部品)をお探しなら、ダイレクトオーダーで。
            <br />
            <br />
            自動車パーツの一括見積システムです。
            <br />
            在庫を検索するのではありませんので、フロントマン様・ご担当者様の手間を軽減しコストカット。
            <br />
            中古・リビルドパーツのヒット率向上もダイレクトオーダーにお任せください。
            <br />
            <br />
            <a href="https://www.direct-order.jp/">&raquo;「ダイレクトオーダー」の資料請求、お問合せはコチラをご確認ください。</a>
            <br />
            <br />
            ※自動車リサイクルパーツ・リビルドパーツサプライヤー様もお待ちしております。
            <p className="contact">
              {" "}
              ■ダイレクトオーダー事務局
              <br />
              &emsp;TEL:<strong>092-710-3912</strong> <span>(平日 10:00～17:00)</span>{" "}
            </p>
          </s.Footer>
        </s.MainContent>

        <s.FooterCopyrightContainer>
          <FooterCopyrightComponent mode={mode} />
        </s.FooterCopyrightContainer>
      </s.BodyBackground>
    </>
  );
}
